import * as ng from 'angular';
import { PanelHeaderData } from '@/atomic-components/molecules/panels';
import { AuthContextService } from '@/services';

export class TemplateMainNewDashboardEditController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PanelHeaderData;

    public constructor(
        private $translate: ng.translate.ITranslateService
    ) {}

    public $onInit(): void {
        const hour = new Date().getHours();
        let greeting;
        let greetingWithoutUsername;

        switch (true) {
            case hour >= 5 && hour < 11: // morning
                greeting = /* translationId */ 'TR_010719-fce241_TR';
                greetingWithoutUsername = /* translationId */ 'TR_250626-90758b_TR';
                break;
            case hour >= 12 && hour < 18: // day
                greeting = /* translationId */ 'TR_010719-a39171_TR';
                greetingWithoutUsername = /* translationId */ 'TR_250626-c0da43_TR';
                break;
            case (hour >= 18 && hour < 24) || hour < 5: // evening & night
                greeting = /* translationId */ 'TR_010719-a5afb3_TR';
                greetingWithoutUsername = /* translationId */ 'TR_250626-751df5_TR';
                break;
        }

        this.pageHeaderData = {
            panelHeaderRoute: '',
            panelIcon: 'home-lg-alt',
            panelTitle: ['', undefined, null].indexOf(AuthContextService.user.name) >= 0
                ? this.$translate.instant(greetingWithoutUsername)
                : this.$translate.instant(greeting, { userName: AuthContextService.user.name })
        };
    }
}

export class TemplateMainNewDashboardEditComponent implements ng.IComponentOptions {
    public bindings = {
        _isAdmin: '<isAdmin'
    };
    public controller = TemplateMainNewDashboardEditController;
    public template = require('./main-dashboard-edit-template.html');
}
